<template>
    <div>
        <div class="home_menu">
            <div class="home_logo">
                <a href="#/"><img src="../assets/logo.png"></a>
            </div>
            <div class="home_hover">
                <span class="login" v-if='p_data.loginState==0'>
                    <em @click='isshowLogin=true'>{{$t('m.log_in')}}</em>
                    <em @click='isshowRegist=true'>{{$t('m.register')}}</em>
                </span>
                
                <span v-if='p_data.loginState==1'>
                    <em>{{p_data.userName}}</em>
                    <div class="hover_bj">
                        <ol style="border-bottom:1px dashed #a8a8a8;"><a href="#/order">{{$t('m.Order_management')}}</a></ol>
                        <ol @click='storageLocal'>{{$t('m.quit')}}</ol>
                    </div>
                </span>
                <b @click="$toggle_lang"></b>
            </div>
            <div class="home_menu">
                <ul>
                    <li class="on">{{$t('m.home')}}</li>
                    <li @click="scrollView('me')">{{$t('m.about_us')}}</li>
                    <li @click="scrollView('about')">{{$t('m.service_intro')}}</li>
                    <li @click="scrollView('lianxi')">{{$t('m.contact_us')}}</li>
                </ul>
            </div>
        </div>

        <div class="home_banner">
            <!-- <video autoplay webkit-playsinline="" x5-video-player-type="h5" x5-video-player-fullscreen="true" webkit-playsinline="" preload="auto" muted="" loop="loop" class="venvy-bg-video" src="../assets/video_4_1.mp4" style=" width:100%;"></video> -->
            <img class='home_banner_back' src="../assets/home_ban.png" alt="">
            
            <div class="home_100n">
                <span>{{$t('m.The_largest')}}</span>
                <ol>{{$t('m.North_America')}}</ol>
                <a href="#/index">{{$t('m.Start_repair')}}</a>
            </div>
        </div>


        <div class="service_ptn"  id='me'>
            <h1>{{$t('m.our_service')}}</h1>
            <ul>
                <li class="on">
                    <div class="ov"><span class="a1"></span></div>
                    <ol>{{$t('m.Screen_replacement')}}</ol>
                    <em></em>
                    <b>{{$t('m.Support')}}</b>
                </li>
                
                <li>
                    <div class="ov"><span class="a2"></span></div>
                    <ol>{{$t('m.Memory_upgrade')}}</ol>
                    <em></em>
                    <b>{{$t('m.Support')}}</b>
                </li>
                
                <li>
                    <div class="ov"><span class="a3"></span></div>
                    <ol>{{$t('m.Battery_replacement')}}</ol>
                    <em></em>
                    <b>{{$t('m.Support')}}</b>
                </li>
                
                <li>
                    <div class="ov"><span class="a4"></span></div>
                    <ol>{{$t('m.Can_not_boot')}}</ol>
                    <em></em>
                    <b>{{$t('m.Support')}}</b>
                </li>
                
                <li>
                    <div class="ov"><span class="a5"></span></div>
                    <ol>{{$t('m.Main_board_water')}}</ol>
                    <em></em>
                    <b>{{$t('m.Support')}}</b>
                </li>
                <div class="clear"></div> 
            </ul>
        </div>


        <div class="home_about" id='about'>
            <div class="home_right">
                <div class="home_left"><img src="../assets/aboimg.jpg"></div>
                <div class="ct">
                    <span>{{$t('m.about_us')}}</span>
                    <ol>{{$t('m.North_American')}}</ol>
                    <ul>
                        <li style="margin-top:7px;">
                            <img src="../assets/tb1.gif">
                            <b>{{$t('m.Price_transparency')}}</b>
                        </li>
                        <li>
                            <img src="../assets/tb2.gif">
                            <b>{{$t('m.Quality_assurance')}}</b>
                        </li>
                        <li>
                            <img src="../assets/tb3.gif">
                            <b>{{$t('m.Efficient_maintenance')}}</b>
                        </li>
                        <li>
                            <img src="../assets/tb4.gif">
                            <b>{{$t('m.after_sale_warranty')}}</b>
                        </li>
                        <div class="clear"></div>
                    </ul>
                    
                    <div class="home_tel" id='lianxi'>
                        <em>{{$t('m.service_line')}}：</em>
                        <strong>400-600-800</strong>
                        <b>666</b>
                    </div>
                </div>
            </div>
        </div>

        <alan-regist :isshowRegist='isshowRegist' :close='()=>{isshowRegist = false}' :regi_succ='()=>{isshowRegist = false}'></alan-regist>
        <alan-login :isshowLogin='isshowLogin' :regiButt='()=>{(isshowLogin = false)||(isshowRegist = true)}' :close='()=>{isshowLogin = false}' :login_succ='()=>{isshowLogin = false}'></alan-login>
    </div>
</template>

<script>
    export default {
        name: "home",
        data(){return{
            isshowRegist:false,
            isshowLogin:false,
            p_data:this.$store.state,
        }},
        methods:{
            scrollView(id){
                console.log(id)
                document.getElementById(id).scrollIntoView()
            }
        },
        created(){
            
        }
    }
</script>

<style scoped>

</style>